export default __webpack_public_path__ + "img/6a519815fb3ad9843c1c4de77db8d335.svg";